import "./index.less"


const BaseBox = ({children, style}) =>{
    return <div className="base-box" style={{...style}}>
            {children}
    </div>
}

export default BaseBox